/**
 * The back link every Settings sub-screen carries: Where you're signed in,
 * Blocked list, Notification settings and Sign-in methods. See the Back
 * affordance section of ui-patterns.md.
 */
import { Link } from "@tanstack/react-router";
import type { ReactNode } from "react";

import { BACK_LINK_CLASS } from "../../shell/BackLink";

export const SETTINGS_BACK_LABEL = "Back to Settings";

export const SettingsBackLink = (): ReactNode => (
  <Link
    to="/settings"
    className={BACK_LINK_CLASS}
    data-testid="settings-back-link"
  >
    {SETTINGS_BACK_LABEL}
  </Link>
);
